import { axios } from "~/plugins/request"

export const state = () => {
    return {}
}
export const mutations = {}
export const actions = {

    // 修改456步方案名称
    shanghai({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`updateSchemeNo/updateSchemeNo`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    // 修改第一步方案名称
    forStepOne({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`updateSchemeNo/updateSchemeNoForStepOne`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    // 修改三步方案名称
    forStepThree({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`updateSchemeNo/updateSchemeNoForStepThree`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

}